/** @jsx jsx */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import './Home.css';
import SSRf from 'orbiter-web/lib/SSR';
import { jsx, css } from '@emotion/core';
import { ThemeProvider } from 'emotion-theming';
import { ProjectTheme } from './Theme';
import Page from 'orbiter-web-components/src/components/page/Page';
import Footer from 'orbiter-web-components/src/components/footer/Footer';
import ToggleOnlyMenu, { maxWidthStyling, menuIconStyling } from 'orbiter-web-components/src/components/topbar/ToggleOnlyMenu';
import { orangeGradientStyling, redGradientStyling, blueGradientStyling, greyGradientStyling, copyRightStyling, sideFooterStyling, floatLeftStyling, logoContainerSyling, logoStyling, floatRightStyling, noPaddingStyling, defealtStyling } from './homeCSS';
import Contact from './components/Contact';
import Sanitair from './components/Sanitair';
import Domotica from './components/Domotica';
import Verwarming from './components/Verwarming';
import Elektrisch from './components/Elektrisch';
import Welkom from './components/Welkom';
import Startpagina from './components/Startpagina';
class Home extends React.Component {
    constructor(a) {
        super(a);
        this.linearGradients = {
            white: (t) => css `color: white;`,
            orange: orangeGradientStyling,
            red: redGradientStyling,
            blue: blueGradientStyling,
            grey: greyGradientStyling,
        };
        this.textColors = {
            white: css `color: white;`,
            orange: css `color: #D36703;`,
            red: css `color: #C51227;`,
            blue: css `color: #107EB1;`,
            grey: css `color: #747677;`,
        };
        this.scrollStartRef = React.createRef();
        this.scrollWelkomRef = React.createRef();
        this.scrollElekRef = React.createRef();
        this.scrollDomoRef = React.createRef();
        this.scrollVerwRef = React.createRef();
        this.scrollSanRef = React.createRef();
        this.scrollContRef = React.createRef();
        this.selector = React.createRef();
        this.state = {
            menuColor: 'white',
            secondaryColor: 'orange',
            menuVisible: false,
            closestRef: undefined,
        };
        this.colorMap = [
            { key: this.scrollStartRef, value: 'white', secondaryValue: 'orange' },
            { key: this.scrollWelkomRef, value: 'white', secondaryValue: 'orange' },
            { key: this.scrollElekRef, value: 'orange', secondaryValue: 'white' },
            { key: this.scrollDomoRef, value: 'white', secondaryValue: 'red' },
            { key: this.scrollVerwRef, value: 'red', secondaryValue: 'white' },
            { key: this.scrollSanRef, value: 'white', secondaryValue: 'blue' },
            { key: this.scrollContRef, value: 'white', secondaryValue: 'grey' },
        ];
    }
    static loadServerData(props) {
        return __awaiter(this, void 0, void 0, function* () {
            // const q = __non_webpack_require__('orbiter-core/src/MongoDatabaseConnection');
            // const db = await q.default();
            // const theDB = db.getDb();
            // console.log(theDB);
            // const collection = db.getCollection('section');
            // console.log(collection);
            // const postcode = collection.find({strid: 'postcode'});
            // console.log('postcode:', postcode);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        test: 'to SSR!',
                        // postcode,
                    });
                }, 500);
            });
        });
    }
    componentDidMount() {
        this.determineMenuIconColor();
        window.addEventListener('scroll', this.determineMenuIconColor.bind(this));
    }
    componentWillUnMount() {
        window.removeEventListener('scroll', this.determineMenuIconColor.bind(this));
    }
    scrollToRef(ref) {
        if (ref) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }
    getMenuIcon() {
        const color = this.state.menuVisible ? this.state.secondaryColor : this.state.menuColor;
        return (jsx("svg", { css: menuIconStyling, width: "56", height: "44", viewBox: "0 0 56 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            jsx("path", { d: "M53 3H3", stroke: `url(#${color}`, strokeWidth: "5", strokeLinecap: "square" }),
            jsx("path", { d: "M53 22H3", stroke: `url(#${color}`, strokeWidth: "5", strokeLinecap: "square" }),
            jsx("path", { d: "M53 41H3", stroke: `url(#${color}`, strokeWidth: "5", strokeLinecap: "square" }),
            jsx("defs", null,
                jsx("linearGradient", { id: "orange", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#E4A004" }),
                    jsx("stop", { offset: "1", stopColor: "#C12B01" })),
                jsx("linearGradient", { id: "white", x1: "3", y1: "22.5", x2: "53", y2: "22.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#FFFFFF" })),
                jsx("linearGradient", { id: "red", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#EC2032" }),
                    jsx("stop", { offset: "0.50102", stopColor: "#C51227", stopOpacity: "0.786515" }),
                    jsx("stop", { offset: "1", stopColor: "#9F041B" })),
                jsx("linearGradient", { id: "blue", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#1A94C1" }),
                    jsx("stop", { offset: "1", stopColor: "#04639F" })),
                jsx("linearGradient", { id: "grey", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#9EA0A0" }),
                    jsx("stop", { offset: "1", stopColor: "#444647" })))));
    }
    getMenuBullet(ref) {
        const color = this.state.menuVisible ? this.state.secondaryColor : this.state.menuColor;
        const filled = ref === this.state.closestRef;
        return (jsx("svg", { css: maxWidthStyling, width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            jsx("circle", { cx: "40", cy: "40", r: "37.5", fill: filled ? `url(#${color})` : 'none', stroke: `url(#${color})`, strokeWidth: "5" }),
            jsx("defs", null,
                jsx("linearGradient", { id: "orange", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#E4A004" }),
                    jsx("stop", { offset: "1", stopColor: "#C12B01" })),
                jsx("linearGradient", { id: "white", x1: "3", y1: "22.5", x2: "53", y2: "22.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#FFFFFF" })),
                jsx("linearGradient", { id: "red", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#EC2032" }),
                    jsx("stop", { offset: "0.50102", stopColor: "#C51227", stopOpacity: "0.786515" }),
                    jsx("stop", { offset: "1", stopColor: "#9F041B" })),
                jsx("linearGradient", { id: "blue", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#1A94C1" }),
                    jsx("stop", { offset: "1", stopColor: "#04639F" })),
                jsx("linearGradient", { id: "grey", x1: "3", y1: "3.5", x2: "53", y2: "3.5", gradientUnits: "userSpaceOnUse" },
                    jsx("stop", { stopColor: "#9EA0A0" }),
                    jsx("stop", { offset: "1", stopColor: "#444647" })))));
    }
    determineMenuIconColor() {
        const distanceToTop = 60;
        let closestRef = { key: this.scrollStartRef, distance: -50000, color: 'white', secondaryColor: 'orange' };
        this.colorMap.forEach((color) => {
            if (color.key !== undefined) {
                const node = ReactDOM.findDOMNode(color.key.current);
                const rect = node !== null ? node.getBoundingClientRect() : null;
                if (rect !== null && rect.top > closestRef.distance && rect.top < distanceToTop) {
                    closestRef = { key: color.key, distance: rect.top, color: color.value, secondaryColor: color.secondaryValue };
                }
            }
        });
        this.setState({ closestRef: closestRef.key, menuColor: closestRef.color, secondaryColor: closestRef.secondaryColor });
    }
    getMenuLinks(toggle) {
        const clickStyling = css `
            padding-left: 10px;
            list-style: none;
            font-size: 20px;
            &:hover{
                text-decoration: underline;
                cursor: pointer;
            }
        `;
        const scrollToPageSection = (section) => {
            this.scrollToRef(section);
            toggle();
        };
        const bulletImageStyling = css `
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-right: 10px;
        `;
        return (jsx("div", { css: (t) => {
                return css `
                    text-align: left;
                    ${this.getTextGradientStyling((t), this.state.secondaryColor)}
                `;
            } },
            jsx("div", { css: (t) => {
                    return css `
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        width: 100%;
                        padding: 30px;
                    `;
                } },
                jsx("img", { css: (t) => {
                        return css `
                        object-fit: contain;
                    `;
                    }, src: `images/logos/${this.state.secondaryColor}@2x.png` })),
            jsx("div", null,
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollStartRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollStartRef)),
                    "Start"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollWelkomRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollWelkomRef)),
                    "Welkom"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollElekRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollElekRef)),
                    "Elektrische installaties"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollDomoRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollDomoRef)),
                    "Domotica"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollVerwRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollVerwRef)),
                    "Verwarming"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollSanRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollSanRef)),
                    "Sanitair"),
                jsx("div", { css: clickStyling, onClick: () => scrollToPageSection(this.scrollContRef) },
                    jsx("span", { css: bulletImageStyling }, this.getMenuBullet(this.scrollContRef)),
                    "Contact"))));
    }
    getRightLogo() {
        const divStyling = css `
            background-color: transparent;
            position: fixed;
            top: 0;
            right: 0;
            padding: 20px;
            width: 80px;
        `;
        const imgStyling = css `
            object-fit: contain;
            width: 100%;
        `;
        return (jsx("div", { css: divStyling },
            jsx("img", { css: imgStyling, src: `images/logos/${this.state.menuColor}@1x.png` })));
    }
    getMenuBackgroundStyling(t) {
        return css `
            ${this.linearGradients[this.state.menuColor](t)};
        `;
    }
    getTextGradientStyling(t, color) {
        return this.textColors[color];
    }
    render() {
        const copyRight = jsx("div", { css: copyRightStyling },
            jsx("div", { css: sideFooterStyling },
                jsx("div", { css: floatLeftStyling }, "Made by Online Orbit")),
            " ",
            jsx("div", { css: logoContainerSyling },
                jsx("img", { css: logoStyling, src: "/images/logos/orig_logo.png" })),
            jsx("div", { css: sideFooterStyling },
                jsx("div", { css: floatRightStyling }, new Date().getFullYear())));
        const footer = jsx(Footer, { copyRight: copyRight, copyRightContainerStyling: noPaddingStyling });
        return (jsx(ThemeProvider, { theme: ProjectTheme },
            jsx("div", { className: "Home", css: defealtStyling },
                jsx(Page, { menu: jsx(ToggleOnlyMenu, { mobileLinkMenuContainerStyling: (t) => this.getMenuBackgroundStyling(t), onToggle: (menuVisible) => this.setState({ menuVisible }), height: "75px", menuIcon: this.getMenuIcon() }, (toggle) => this.getMenuLinks(toggle)), footer: footer },
                    this.getRightLogo(),
                    jsx("div", { ref: this.scrollStartRef },
                        jsx(Startpagina, { onClick: () => { this.scrollToRef(this.scrollWelkomRef); } })),
                    jsx("div", { ref: this.scrollWelkomRef },
                        jsx(Welkom, { sdKey: "welkomkey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'white'), onClick: () => { this.scrollToRef(this.scrollElekRef); } })),
                    jsx("div", { ref: this.scrollElekRef },
                        jsx(Elektrisch, { sdKey: "elektrischkey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'orange'), onClick: () => { this.scrollToRef(this.scrollDomoRef); } })),
                    jsx("div", { ref: this.scrollDomoRef },
                        jsx(Domotica, { sdKey: "domoticakey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'white'), onClick: () => { this.scrollToRef(this.scrollVerwRef); } })),
                    jsx("div", { ref: this.scrollVerwRef },
                        jsx(Verwarming, { sdKey: "verwarmingkey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'red'), onClick: () => { this.scrollToRef(this.scrollSanRef); } })),
                    jsx("div", { ref: this.scrollSanRef },
                        jsx(Sanitair, { sdKey: "sanitairkey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'white'), onClick: () => { this.scrollToRef(this.scrollContRef); } })),
                    jsx("div", { ref: this.scrollContRef },
                        jsx(Contact, { sdKey: "contactkey", sd: this.props.sd, colorCombination: (t) => this.getTextGradientStyling(t, 'white'), onClick: () => { window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' }); } }))))));
    }
}
export default SSRf(Home);
//# sourceMappingURL=Home.js.map